import { useState, useRef, useEffect, useContext } from 'react';
import { Button, Toast } from 'react-weui';
import CompanyService from 'services/company2';
import { ActionContext } from 'actions/context';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Http from 'services/http2';

const styles = {
  paper: {
    margin: '10px',
    width: '90vw'
  }
};

function Upload(props) {
  const { classes, companyCode, isPurchase, detail, onComplete, open, self } =
    props;

  const { state, dispatch } = useContext(ActionContext);
  const [data, setData] = useState([]);
  const [totalFileSize, setTotalFileSize] = useState(0);
  const [error, setError] = useState('');
  const [uploader, setUploader] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileType, setFileType] = useState('file');
  const [allowedFileType, setAllowedFileType] = useState([
    'pdf',
    'doc',
    'docx',
    'jpg',
    'jpeg',
    'png',
    'gif',
    'zip',
    'rar',
    '7z',
    'dwg',
    'dws',
    'dxf',
    'step',
    'stp',
    'xls',
    'xlsx',
    'drw',
    'prt',
    'ppt',
    'pptx',
    'cdr',
    'x_t',
    'pcb',
    'img',
    'msg',
    'txt',
    'ai',
    'ofd',
    'psd',
    'tim'
  ]);

  useEffect(() => {
    let oft = state.config?.ofg;
    let initData = state.config?.initData;
    if (oft) {
      if ([2, 8, 16, 28, 46].includes(oft)) {
        //pdfmake仅支持JPEG and PNG
        setAllowedFileType(['jpg', 'jpeg', 'png']);
        setFileType('image');
      } else if ([1, 40].includes(oft)) {
        setAllowedFileType(['jpg', 'jpeg', 'png', 'gif', 'tiff']);
        setFileType('image');
      } else if ([23].includes(oft)) {
        setAllowedFileType(['xlsx']);
      }
    }
    if (initData) {
      setItemType(initData);
      setData(initData);
      figureTotalSize(initData);
    }
  }, [companyCode, setAllowedFileType, setFileType, state]);

  // 设置附件类型（用于图片类型预览）
  function setItemType(list) {
    list.forEach(item => {
      if (!item.fileType) {
        item.fileType = item.fileName.substring(item.fileName.lastIndexOf('.'));
      }
      item.type =
        ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.webp'].indexOf(
          item.fileType?.toLowerCase()
        ) !== -1
          ? 'image'
          : 'file';
    });
  }

  // 计算当前附件总大小, 队列状态统计
  function figureTotalSize(currData) {
    let currTotalFileSize = 0;
    if (Array.isArray(currData) && currData.length > 0) {
      currTotalFileSize = currData
        .map(item => item.fileSize)
        .reduce((accumulator, currentValue) => accumulator + currentValue);
    }
    setTotalFileSize(currTotalFileSize);
  }

  // 关闭弹窗
  function handleClose() {
    dispatch({ type: 'hideUpload' });
  }

  // 确定
  function handleOk() {
    if (typeof onComplete === 'function') {
      onComplete(data);
    }
    handleClose();
  }

  // 删除已上传文件
  function handleDelete(index) {
    let arr = data.slice(0);
    arr.splice(index, 1);
    setData(arr);
    setError('');
  }

  function selectFile() {
    if (state.config.queueLimit <= uploader.queue?.length) {
      setError('文件上传数量不能超过' + state.config.queueLimit);
      return;
    } else {
      setError('');
    }
    const fileUpload = document.getElementById('fileUpload');
    fileUpload.onchange = () => {
      let length = fileUpload.files.length;
      for (let index = 0; index < length; index++) {
        const file = fileUpload.files[index];
        files.push({ data: file, inProgress: false, progress: 0 });
        uploadFiles({ data: file, inProgress: false, progress: 0 });
      }
    };
    fileUpload.click();
  }

  // 校验文件类型，大小，数量
  function validate(file) {
    // 校验文件类型
    let extension = file.data.name.substring(
      file.data.name.lastIndexOf('.') + 1
    );
    if (allowedFileType) {
      let rs = allowedFileType.includes(extension);

      /**
       *  支持分卷压缩文件
       *    zip:   z01, z02, ..., z99
       *    rar:   r01, r02, ..., r99
       *    7z:    001, 002, ..., 099
       */
      if (allowedFileType.includes('zip') && /^[zr0]\d{2}$/.test(extension)) {
        rs = true;
      }

      if (!rs && error === '') {
        setError('文件类型必须为 ' + allowedFileType.join(' '));
        setIsLoading(false);
        return false;
      }
    }

    // 校验单文件大小
    let maxFileSize = state.config.maxFileSize;
    if (maxFileSize) {
      let rs = file.data.size < maxFileSize * 1024 * 1024;
      if (!rs && error === '') {
        setError('文件大小不能超过' + maxFileSize + 'M');
        setIsLoading(false);
        return false;
      }
    }

    // 校验总大小
    let totalMaxFileSize = state.config.totalMaxFileSize;
    if (totalFileSize && typeof totalMaxFileSize === 'number') {
      let rs = totalFileSize + file.data.size < totalMaxFileSize * 1024 * 1024;
      if (!rs && error === '') {
        setError('文件总大小不能超过' + totalMaxFileSize + 'M');
        setIsLoading(false);
        return false;
      }
    }

    return true;
  }

  function uploadFiles(item) {
    setIsLoading(true);
    uploadFile(item);
  }

  function uploadFile(file) {
    if (!validate(file)) {
      return;
    }

    const formData = new FormData();
    formData.append('file', file.data);
    formData.append('oft', state.config.oft);
    formData.append('companyCode', companyCode);
    formData.append('isOCR', false);
    file.inProgress = true;

    let apiPath =
      '/xkyFsCenter/oss/file/newUpload?visitSource=1002' +
      '&companyCode=' +
      companyCode;

    Http.post(apiPath, formData).then(response => {
      setIsLoading(false);
      if (response && response.success) {
        file.inProgress = false;
        let isPrivate = true;
        let downloadUrl = CompanyService.genDownloadUrl(
          response.data.filePath,
          isPrivate,
          'newUpload'
        );

        let fileData = response.data;

        let currData = data;
        currData.push({
          fileMd5: fileData.fileMd5,
          fileName: fileData.fileName,
          fileSize: fileData.fileSize,
          fileUrl: downloadUrl,
          type: fileType
        });
        setItemType(currData);
        setData(currData);
        figureTotalSize(currData);
      } else {
        setError(response.errorMsg);
      }
    });
  }

  return (
    <div>
      {state.config && (
        <Dialog
          classes={{ paper: classes.paper }}
          open={state.showUpload}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {fileType === 'file' ? '文件上传' : '图片上传'}
          </DialogTitle>
          <DialogContent>
            {/* <FilePond
            files={files}
            // getMetadata={}
            // metadata={{ opt: 32, companyCode: companyCode }}
            // options={filePond}
            // data={filePond}
            onupdatefiles={setFiles}
            allowMultiple={true}
            maxFiles={50}
            server={server}
            name="files"
            labelIdle='<span class="filepond--label-action">上传</span>'
          /> */}
            <div>
              {(fileType === 'file' || fileType === 'image') && (
                <p className="f12">
                  <span>
                    共{data.length}个 (
                    {(totalFileSize / 1024 / 1024).toFixed(2)}
                    M), 还能上传
                    {state.config.queueLimit - data.length}个, 单文件大小不超过
                    {state.config.maxFileSize}M
                  </span>
                  {state.config.totalMaxFileSize && (
                    <span>, 总大小不超过{state.config.totalMaxFileSize}M</span>
                  )}
                </p>
              )}
              {error && <p className="error-msg">{error}</p>}

              <input
                type="file"
                id="fileUpload"
                name="filepond"
                style={{ display: 'none' }}
                required
                multiple
              />
              <ul className="file-list clearfix">
                {data.length > 0 &&
                  data.map(
                    (item, index) =>
                      (item.type.indexOf('image') !== -1 && (
                        <li
                          key={index}
                          className="image"
                          style={{
                            backgroundImage: 'url(' + item.fileUrl + ')'
                          }}
                        >
                          <i
                            className="icon-close"
                            onClick={() => handleDelete(index)}
                          ></i>
                        </li>
                      )) ||
                      (item.type.indexOf('image') === -1 && (
                        <li key={index} className="file">
                          <i className="icon-file-text"></i>
                          <p className="f-points" title="{item.fileName}">
                            {item.fileName}
                          </p>
                          <i
                            className="icon-close"
                            onClick={() => handleDelete(index)}
                          ></i>
                        </li>
                      ))
                  )}
                {isLoading && (
                  <li className="load">
                    <img src="./assets/img/loading.gif" alt="" />
                    <p>处理中，稍等片刻...</p>
                  </li>
                )}
                {state.config.queueLimit - data.length > 0 && (
                  <li className="selectFile" onClick={() => selectFile()}>
                    <i className="icon-plus"></i>
                  </li>
                )}
              </ul>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="w100 m-flex-box">
              <Button
                className="m-flex-item u-btn u-btn_primary"
                onClick={handleOk}
                color="primary"
              >
                确定
              </Button>
              <Button
                className="m-flex-item u-btn u-btn_primary"
                onClick={handleClose}
                color="primary"
              >
                关闭
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      )}
      <Toast icon="loading" show={state.showLoading}>
        Loading...
      </Toast>
    </div>
  );
}

Upload.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Upload);
